module.exports = __webpack_public_path__ + "static/Phone1-6dffacb2350412b92ae01d72bb873449.png";